import { render, staticRenderFns } from "./AStaffDetailMaintainance.vue?vue&type=template&id=0be5a2a0&scoped=true"
import script from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
export * from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailMaintainance.vue?vue&type=style&index=0&id=0be5a2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5a2a0",
  null
  
)

export default component.exports